export function getCountries() {
    return [
        { value: 'PL', label: 'Polska' }
    ];
}

export function getCountryLabelByCode(code) {
    return getCountries().find((val) => val.value === code)?.label;
}